export enum PendingVisitLoadingDenialReasons {
  NoVisitFound = 'No visit found',
  VenueNotFound = 'Venue not found',
  AlreadyCheckedOut = 'Already checked out',
  InvalidTokenId = 'Invalid token Id',
  InvalidToken = 'Invalid token'
}
